import React, { useState, useEffect } from "react";
import Modal from "../../../components/modal";
import List from "../scenes/learn/list";
import { IoClose } from "react-icons/io5";
import { toast } from "react-hot-toast";
import api from "../../../services/api";

export function AddWorkshopModal({ training, defaultChapter, onDone }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedChapter, setSelectedChapter] = useState(defaultChapter);

  useEffect(() => {
    setSelectedChapter(defaultChapter);
  }, [defaultChapter]);

  const handleWorkshopSelect = async (workshop) => {
    try {
      if (!selectedChapter) return;

      const isNewChapter = !training.chapter_order.includes(selectedChapter);
      let updatedTraining = training;

      // If it's a new chapter, update the chapter order first
      if (isNewChapter) {
        const updatedChapterOrder = [selectedChapter, ...training.chapter_order];
        const { ok: chapterOk } = await api.put(`/training/${training._id}`, { chapter_order: updatedChapterOrder });

        if (!chapterOk) throw new Error("Failed to create new chapter");

        updatedTraining = { ...training, chapter_order: updatedChapterOrder };
      }

      // Add the workshop
      const { data, ok } = await api.post("/training_workshop", {
        training_id: training._id,
        workshop_id: workshop._id,
        chapter: selectedChapter,
        position: 0,
        workshop_name: workshop.name,
        workshop_image: workshop.image,
        workshop_description: workshop.description,
      });

      if (!ok) throw new Error("Failed to add workshop");

      setIsOpen(false);
      setSelectedChapter(defaultChapter);

      onDone(updatedTraining, data);

      // Show success message
      toast.success(isNewChapter ? "New chapter and workshop added successfully!" : "Workshop added successfully!");
    } catch (error) {
      toast.error("Failed to add workshop");
    }
  };

  if (!isOpen) {
    return (
      <button onClick={() => setIsOpen(true)} className="w-full flex items-center gap-2 px-2.5 py-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-50 border-t border-gray-200">
        <div className="w-4 h-4" />
        <div className="w-5 h-5 rounded overflow-hidden flex-shrink-0 bg-gray-100 border border-gray-200 flex items-center justify-center">
          <IoClose className="w-3.5 h-3.5 rotate-45" />
        </div>
        <span className="text-sm">Add Workshop</span>
      </button>
    );
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
        setSelectedChapter(defaultChapter);
      }}
      className="max-w-6xl w-full">
      <div className="p-4 max-h-[90vh] overflow-y-auto">
        <div className="flex flex-col mb-4">
          <h2 className="text-lg font-semibold mb-4">Add Workshop</h2>
          <div className="flex flex-wrap gap-2 mb-4">
            {training.chapter_order.map((chapter) => (
              <button
                key={chapter}
                onClick={() => setSelectedChapter(chapter)}
                className={`px-3 py-1.5 rounded-lg text-sm transition-all duration-200 flex items-center ${
                  selectedChapter === chapter ? "bg-[#3D8B9F] text-white" : "bg-[#66D9EF]/10 text-[#3D8B9F] border border-[#66D9EF]/20 hover:bg-[#66D9EF]/20"
                }`}>
                {chapter}
              </button>
            ))}
          </div>
          {selectedChapter && <p className="text-xs text-gray-600 mb-4">Adding to chapter: {selectedChapter}</p>}
        </div>

        <List onWorkshopClick={handleWorkshopSelect} />
      </div>
    </Modal>
  );
}
